import callAPI from "config/callAPI";
import LandingAuth from "config/auth/LandingAuth";

import React from "react";

import AccountHeader from "pages/account/includes/AccountHeader";
import AccountFooter from "pages/account/includes/AccountFooter";

const ENDPOINT = process.env.REACT_APP_BACKEND_URL + '/activate';

class Activate extends React.Component {
    
    constructor(){
        LandingAuth();

        super();
        this.state = {
            alertColor: '',
            rstatus: '',
            rmessage: '',
            rdata: []
        } 

        this.getActivationStatus();
    }

    async getActivationStatus() {
        const location = window.location;
        const queryParams = new URLSearchParams(location.search);

        var userid = queryParams.get('userid');
        var token = queryParams.get('token');
        var data = {userid: userid, token: token};

        const {rstatus, rmessage, rdata } = await callAPI(ENDPOINT, data); 
        this.setState({
            rstatus: rstatus,
            rmessage: rmessage,
            rdata: rdata
        });
        
        if (rstatus === true){ this.setState({alertColor: 'green'}); } 
        else if (rstatus === false) { this.setState({alertColor: 'red'}); }
    }

    render() {
        return (
            <>
                <AccountHeader />
                
                <div className="container sm:px-10">
                    <div className="block xl:grid grid-cols-2 gap-4">
                        <div className="hidden xl:flex flex-col min-h-screen">
                            <a href="/" className="-intro-x flex items-center pt-5">
                                <img alt="Midone Tailwind HTML Admin Template" className="w-6" src="assets/midone/images/logo.png" />
                                <span className="text-white text-lg ml-3"> U<span className="font-medium">Short</span> </span>
                            </a>
                            <div className="my-auto">
                                <img alt="Midone Tailwind HTML Admin Template" className="-intro-x w-1/2 -mt-16" src="assets/midone/images/illustration.svg" />
                                <div className="-intro-x text-white font-medium text-4xl leading-tight mt-10">
                                    Welcome to UShort!
                                    <br/>
                                    
                                </div>
                                <div className="-intro-x mt-5 text-lg text-white dark:text-gray-500">Activate your account to create shortened URLs and track performance.</div>
                            </div>
                        </div>
                        <div className="h-screen xl:h-auto flex py-5 xl:py-0 my-10 xl:my-0 login">
                            <div className="my-auto mx-auto xl:ml-20 bg-white xl:bg-transparent px-5 sm:px-8 py-8 xl:p-0 rounded-md shadow-md xl:shadow-none w-full sm:w-3/4 lg:w-2/4 xl:w-auto">
                                <h2 className="intro-x font-bold text-2xl xl:text-3xl text-center xl:text-left">
                                    Activation Status <hr/>
                                </h2>
                                <div className="intro-x mt-2 text-gray-500 xl:hidden text-center">Welcome to UShort! Activate your account to create shortened URLs and track performance.</div>
                                { this.state.rstatus !== '' ?
                    
                                    <p style={{ color: this.state.alertColor, paddingTop: 10, paddingRight: 10}}>
                                        {this.state.rmessage}  Go back to the <a href="/signin" style={{color: 'blue'}}>Signin</a> page!
                                    </p>
                    
                                    : ""
                                }
                            </div>
                        </div>
                    </div>
                </div>

                <AccountFooter />
            </>
        );
    }
}

export default Activate;
